export const environment = {
  baseUrl: 'https://api.nusaresidence.com',
  apiUrl: 'https://api.nusaresidence.com/api'
}
